

// Configure each font with consistent settings





export const fontOptions = [
    // Standard Fonts
    { label: "Arial", value: "Arial" },
    { label: "Courier New", value: "Courier+New" },
    { label: "Times New Roman", value: "Times+New+Roman" },
    { label: "Georgia", value: "Georgia" },
    { label: "Verdana", value: "Verdana" },

    // Popular Google Fonts
    { label: "Roboto", value: "Roboto" },
    { label: "Open Sans", value: "Open+Sans" },
    { label: "Lora", value: "Lora" },
    { label: "Lato", value: "Lato" },
    { label: "Montserrat", value: "Montserrat" },
    { label: "Poppins", value: "Poppins" },
    { label: "Raleway", value: "Raleway" },
    { label: "Inter", value: "Inter" },
    { label: "Playfair Display", value: "Playfair+Display" },

    // ✨ Unique / Weirder Fonts
    { label: "Caveat", value: "Caveat" },
    { label: "Pacifico", value: "Pacifico" },
    { label: "Fredoka", value: "Fredoka" },
    { label: "Indie Flower", value: "Indie+Flower" },
    { label: "Amatic SC", value: "Amatic+SC" },
    { label: "Bangers", value: "Bangers" },
    { label: "Abril Fatface", value: "Abril+Fatface" },
    { label: "Chewy", value: "Chewy" },
    { label: "Merienda", value: "Merienda" },
    { label: "Press Start 2P", value: "Press+Start+2P" },
    { label: "Zilla Slab Highlight", value: "Zilla+Slab+Highlight" },
    { label: "Monoton", value: "Monoton" },
    { label: "Orbitron", value: "Orbitron" },
    { label: "Luckiest Guy", value: "Luckiest+Guy" },
    { label: "VT323", value: "VT323" },
];



// Helper to check if a font is a system font (already defined in your code, included for completeness)

// Template data
export const templates = [
    {
        name: "Modern Style for Company Profile Website",
        value: "design1",
        imageUrl: "/images/design1.webp",
    },

    {
        name: "Minimalist Style for Company Profile Website",
        value: "design2",
        imageUrl: "/images/design3.webp",
    },
    {
        name: "Professional Style for Company Profile Website",
        value: "design3",
        imageUrl: "/images/design2.webp",
    },
];

// Color options
export const colorOptions = [
    "#003DAD",
    "#FF8C00",
    "#FFD700",
    "#00FF00",
    "#00FFFF",
    "#003DAD",
    "#800080",
    "#FF69B4",
];